<app-header></app-header>

<div class="flex mt-2">
  <app-sidebar optionMenu="12"></app-sidebar>

  <div class="pt-5 pb-10 w-full md:px-12 lg:px-20">
    <button [routerLink]="['/home-video']" class="w-[90px] flex items-center gap-2 mY-8">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15 19L8 12L15 5" stroke="#038652" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span class="font-bold text-sm text-[#666]">{{ 'Modules.Back' | transloco }}</span>
    </button>

    <form [formGroup]="formsVideo" class="mx-auto max-w-screen-xl">
      <div class="flex justify-between items-center">
        <h1 class="text-2xl font-bold">{{ 'block-video.form' | transloco }}</h1>

        <button type="submit" (click)="submitForm()"
          class="flex items-center justify-center w-52 h-[56px] p-4 rounded-lg bg-purple-purple6">
          <span class="text-white font-semibold text-sm pl-3">{{ 'block-video.save' | transloco}}</span>
        </button>
      </div>

      <div class="bg-white rounded-2xl shadow-md mx-auto mt-8 p-10 w-full flex flex-col">
        <div class="mb-6">
          <label class="block text-base text-dark-light mb-3">Titulo del video</label>
          <input type="text" formControlName="titulo"
            class="h-12 px-3 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-light-light"
            placeholder="Titulo del video">

          <div *ngIf="formsVideo.get('titulo')?.invalid && formsVideo.get('titulo')?.touched"
            class="text-red-500 text-sm mt-1">
            <span *ngIf="formsVideo.get('titulo')?.errors?.['required']">
              El campo titulo es obligatorio.
            </span>
          </div>
        </div>

        <div class="mb-6">
          <label class="block text-base text-dark-light mb-3">Video embebido</label>
          <textarea formControlName="embebido" class="w-full border rounded-xl px-3 py-2 text-sm bg-light-light"
            rows="3" placeholder='Pega aquí el iframe de YouTube'>
          </textarea>

          <div *ngIf="formsVideo.get('embebido')?.invalid && formsVideo.get('embebido')?.touched"
            class="text-red-500 text-sm mt-1">
            <span *ngIf="formsVideo.get('embebido')?.errors?.['required']">
              El campo de video es obligatorio.
            </span>
            <span *ngIf="formsVideo.get('embebido')?.errors?.['pattern']">
              Debes ingresar un iframe válido de YouTube.
            </span>
          </div>
        </div>

        <div class="mb-6">
          <label class="block text-base text-dark-light mb-3">Tags (máximo 5 tags por video)</label>

          <!-- Botón / input visual -->
          <div class="relative flex-1">
            <button type="button" class="w-full min-h-[42px] border rounded-xl px-3 py-2 text-sm text-left bg-light-light 
                    focus:outline-none focus:ring-2 focus:ring-indigo-500 flex flex-wrap gap-2 cursor-pointer "
              (click)="dropdownOpenTags = !dropdownOpenTags">

              <span *ngIf="selectedTagsValue.length === 0" class="text-gray-400">
                Selecciona una o varias tags...
              </span>

              <span *ngFor="let tagName of selectedTagsValue"
                class="bg-purple-purple7 text-purple-purple8 px-2 py-1 rounded-full text-xs flex items-center">
                {{ tagName }}
                <button type="button" (click)="removeTag(tagName)" class="ml-1 text-purple-purple8 hover:text-pink-700">
                  ✕
                </button>
              </span>
            </button>

            <!-- Dropdown -->
            <div *ngIf="dropdownOpenTags"
              class="absolute mt-1 w-full bg-white border rounded-xl shadow z-30 max-h-40 overflow-y-auto">

              <!-- Campo de búsqueda -->
              <div class="px-3 py-2 border-b">
                <input type="text" formControlName="tagSearch" placeholder="Buscar tag..."
                  class="w-full px-2 py-1 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500" />
              </div>

              <!-- Mensajes de estado -->
              <div class="mt-2 text-sm" *ngIf="tagAvailability !== null">
                <span *ngIf="tagAvailability; else notAvailable" class="text-green-600 font-medium">
                  Tag disponible
                </span>
                <ng-template #notAvailable>
                  <span class="text-red-600 font-medium"> Tag no disponible</span>
                </ng-template>
              </div>

              <div *ngFor="let tag of filteredTags; trackBy: trackByTag" (click)="toggleTag(tag.nombre)"
                class="px-3 py-2 cursor-pointer hover:bg-blue-blue3 flex items-center">
                <input type="checkbox" [checked]="isTagSelected(tag.nombre)" class="mr-2 " tabindex="-1" />
                {{ tag.nombre }}
              </div>

              <!-- Si no hay coincidencias -->
              <div *ngIf="filteredTags.length === 0" class="px-3 py-2 text-gray-400 text-sm">
                No se encontraron resultados.
              </div>

            </div>
          </div>
        </div>

        <div class="mb-6">
          <label class="block text-base text-dark-light mb-3">Contenido</label>
          <textarea formControlName="contenido"
            class="h-32 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm bg-light-light resize-none"
            placeholder="Contenido textual o adicional del video">
          </textarea>

          <div *ngIf="formsVideo.get('contenido')?.invalid && formsVideo.get('contenido')?.touched"
            class="text-red-500 text-sm mt-1">
            <span *ngIf="formsVideo.get('contenido')?.errors?.['required']">
              El campo contenido es obligatorio.
            </span>
          </div>
        </div>

        <div class="mb-6" *ngIf="isEditMode">
          <label class="block text-base text-dark-light mb-3">Estado del bloque de video</label>

          <div class="flex items-center">
            <label class="relative inline-flex items-center cursor-pointer">
              <input type="checkbox" [checked]="formsVideo.get('estado')?.value === 'activo'" class="sr-only peer"
                (change)="onToggleStatus($event)" />
              <div
                class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:bg-indigo-600 relative">
                <div
                  class="absolute top-0.5 left-0.5 bg-white border rounded-full h-5 w-5 transition-all peer-checked:translate-x-full">
                </div>
              </div>
            </label>
            <span class="ml-3 text-sm text-gray-700">
              {{ formsVideo.get('estado')?.value}}
            </span>
          </div>
        </div>

      </div>

    </form>

  </div>
</div>